/* A slider that behaves the same on every device.

   The theme's grid-slider turns itself off on a touch device and leaves the
   browser to scroll, so a phone gets no arrows at all. People use both: they
   swipe and they tap. This keeps the native scrolling, which is what makes a
   swipe feel right, and puts the theme's own arrows on top of it so there is
   always something to press.

   It takes the theme's arrow markup, so it looks like every other slider. */
(function () {
  var SLIDER = '[data-bakkeleg-slider]';

  function init(root) {
    if (root.dataset.sliderReady === 'true') return;
    root.dataset.sliderReady = 'true';

    var track = root.querySelector('[data-bakkeleg-track]');
    var prev = root.querySelector('[data-button-prev]');
    var next = root.querySelector('[data-button-next]');
    if (!track) return;

    function step() {
      var slide = track.firstElementChild;
      if (!slide) return track.clientWidth;
      var style = getComputedStyle(slide);
      var margin = parseFloat(style.marginRight) || 0;
      return slide.getBoundingClientRect().width + margin;
    }

    function update() {
      var overflows = track.scrollWidth - track.clientWidth > 4;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;

      root.classList.toggle('bakkeleg-slider--static', !overflows);
      if (prev) prev.disabled = !overflows || atStart;
      if (next) next.disabled = !overflows || atEnd;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollLeft -= step(); });
    if (next) next.addEventListener('click', function () { track.scrollLeft += step(); });

    track.addEventListener('scroll', update, {passive: true});
    window.addEventListener('resize', update);
    update();

    /* the pictures change the track's width as they arrive */
    window.setTimeout(update, 400);
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
  }

  function bind(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var sliders = root.querySelectorAll(SLIDER);
    for (var i = 0; i < sliders.length; i++) init(sliders[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
  document.addEventListener('bakkeleg:upsell:loaded', function (event) { bind(event.target); });
})();
